import { EuglenaName, Particle } from "@euglena/compact";

let particles: Particle[] = [];
particles = [
  new EuglenaName("website.frontend")
];

export default particles;
